// tslint:disable
import { callStatic, GetCatalogItemsForCommentsPinboardResponse } from 'services/api-service'

/**
 * Retrieve catalog items containing comments for the comments pinboard
 *
 * @method
 * @name ApiService#getCatalogItemsForCommentsPinboard
 * @param {string} skus -
 * @param {integer} offset -
 * @param {integer} limit -
 * @param {boolean} activeOnly -
 * @param {string} brands -
 * @param {string} tags -
 * @param {boolean} includeCommentsCount -
 * @param {boolean} includeReviewData -
 * @param {integer} maxDaysOld - Specify -1 to include all, regardless of age
 * @param {boolean} includeSyndicated -
 * @param {integer} minComments -
 * @param {integer} maxCommentsReturned -
 */
function getCatalogItemsForCommentsPinboard(parameters: {
  skus: string
  offset: number
  limit: number
  activeOnly: boolean
  brands: string
  tags: string
  includeCommentsCount: boolean
  includeReviewData: boolean
  maxDaysOld: number
  includeSyndicated: boolean
  minComments: number
  maxCommentsReturned: number
}): Promise<GetCatalogItemsForCommentsPinboardResponse> {
  return callStatic<GetCatalogItemsForCommentsPinboardResponse>(
    '/sitedata/{siteKey}/commentsPinboard/{skus}/{locale}/{offset}/{limit}/{activeOnly}/{brands}/{tags}/{includeCommentsCount}/{includeReviewData}/{maxDaysOld}/{includeSyndicated}/{minComments}/{maxCommentsReturned}',
    parameters,
    [
      'skus',
      'offset',
      'limit',
      'activeOnly',
      'brands',
      'tags',
      'includeCommentsCount',
      'includeReviewData',
      'maxDaysOld',
      'includeSyndicated',
      'minComments',
      'maxCommentsReturned'
    ]
  )
}

export default { getCatalogItemsForCommentsPinboard }
